import React from 'react';
import { useTranslation } from 'react-i18next';
import { T, H_TITLE } from './declarationTheme';
import StepContratAssureurs from './StepContratAssureurs';
import StepAssureVehicule from './StepAssureVehicule';
import StepConducteur from './StepConducteur';

/* ─────────────────────────────────────────────────────────────
   Étape 2 unifiée - Conducteur, contrat, assuré & véhicule
   Regroupe les anciennes étapes Contrat + Assuré/Véhicule + Conducteur
   pour fluidifier la saisie. L'ordre logique est :
     1. Contrat & assureurs (avec lookup attestation qui pré-remplit la suite)
     2. Assuré & véhicule
     3. Conducteur (souvent = assuré, toggle disponible)
   ───────────────────────────────────────────────────────────── */

const SUBSECTION_HEADER = (titre, hint) => (
  <div style={{
    marginTop: 36,
    marginBottom: 20,
    paddingBottom: 12,
    borderBottom: `1px solid ${T.line}`,
  }}>
    <div style={{
      fontSize: 16,
      fontWeight: 600,
      color: T.brand,
      letterSpacing: '-0.005em',
    }}>
      {titre}
    </div>
    {hint && (
      <div style={{ fontSize: 12.5, color: T.inkMuted, marginTop: 4 }}>
        {hint}
      </div>
    )}
  </div>
);

export default function StepConducteurContrat({ form, organismes = [], pays = [] }) {
  const { t } = useTranslation('declaration');
  return (
    <div style={{ maxWidth: 760 }}>
      <h1 style={H_TITLE}>{t('conducteurContrat.titre')}</h1>

      {/* ── 1. Contrat & assureurs (avec lookup attestation) ── */}
      {SUBSECTION_HEADER(
        t('conducteurContrat.contratAssureurs'),
        t('conducteurContrat.contratAssureursIndication')
      )}
      <StepContratAssureurs
        form={form}
        organismes={organismes}
        pays={pays}
        embedded
      />

      {/* ── 2. Assuré & véhicule ── */}
      {SUBSECTION_HEADER(t('conducteurContrat.assureVehicule'))}
      <StepAssureVehicule form={form} embedded />

      {/* ── 3. Conducteur ── */}
      {SUBSECTION_HEADER(t('conducteurContrat.conducteur'))}
      <StepConducteur form={form} embedded />
    </div>
  );
}
